<template>
  <div id="roles">
    <top-menu></top-menu>


    <b-table
        ref="rolesTable"
        :items="ROLES_DATA"
        :fields="fieldsLabel"
        striped
        bordered="bordered"
        head-variant="light"
        fixed
        v-if="IS_LOAD"
    >
      <template v-slot:cell(name)="data">
        <i class="t-cell cell-cursor"
           v-on:click.prevent="editCell(data.index, data.field.key)"
           :ref="'cell_view_' + data.index +'_'+ data.field.key"
           v-b-tooltip.hover :title="data.value"
        >
          {{ data.value }}
        </i>
        <b-input
            class="edit-cell"
            type="text"
            v-model="ROLES_DATA[data.index][data.field.key]"
            v-on:change="changeCell(data.index, data.field.key)"
            :ref="'cell_edit_' + data.index +'_'+ data.field.key"
            style="display: none"
        ></b-input>
      </template>
      <template v-slot:cell(id)="data">
        <i class="t-cell">
          {{ data.value }}
        </i>
      </template>
      <template v-slot:cell(action)="data">
        <b-button
            v-if="data.item.name != 'Администратор' || data.item.id != 1"
            size="sm"
            v-on:click.prevent="roleDelete(data.index, data.item.name)"
        >Удалить
        </b-button>
      </template>
      <template v-slot:cell()="data">
        <div>
          <b-form-checkbox size="sm"
                           v-model="ROLES_DATA[data.index][data.field.key]"
                           v-on:change="changeCellSection(data.index)"
                           :checked="ROLES_DATA[data.index][data.field.key] === true"
          ></b-form-checkbox>
        </div>
      </template>
    </b-table>

    <b-button
        variant="primary"
        class="float-right"
        v-on:click="SAVE()"
    >
      Сохранить
    </b-button>

    <div class="add-role">
      <b-button v-b-toggle.addRole variant="primary">
        Добавить группу
      </b-button>
      <b-collapse id="addRole" class="mt-2">
        <b-card>
          <b-form v-on:submit="addRole()">
            <b-container fluid>
              <b-row class="input-add-use mb-3">
                <b-col sm="2">
                  <label for="input-1">Название:</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="input-1" size="sm" v-model="name" required></b-form-input>
                </b-col>
              </b-row>

              <b-row class="input-add-use" v-for="section in SECTIONS_LIST" v-bind:key="section.name">
                <b-col sm="2">
                  <label :for="'input-'+ section.name">{{ section.alias }}:</label>
                </b-col>
                <b-col sm="10">
                  <b-form-checkbox :id="'input-'+ section.name" size="sm" v-model="newRole[section.name]"></b-form-checkbox>
                </b-col>
              </b-row>

              <b-row class="input-add-use">
                <b-button type="submit" variant="primary">Создать</b-button>
              </b-row>
            </b-container>
          </b-form>
        </b-card>
      </b-collapse>
    </div>

    <b-modal id="roleDuplicateError" hide-footer title="Ошибка">
      <p class="error-content"> Роль с таким названием уже существует </p>
      <b-button class="mt-3" variant="outline-error" block @click="$bvModal.hide('roleDuplicateError')">Ок</b-button>
    </b-modal>

  </div>
</template>

<script>
import topMenu from "@/components/users/components/topMenu";
import {createNamespacedHelpers} from "vuex";

const {mapGetters, mapActions} = createNamespacedHelpers('users/roles');

export default {
  name: "roles",
  data() {
    return {
      rolesVal: [],
      name: '',
      newRole: {},
      userSection: false,
      brandSection: false,
      productSection: false,
      translationsSection: false,
      analyticsSection: false,
      sitesSection: false,
      alertSection: false,
      orderSection: false,
      configSection: false,
    }
  },
  components: {
    topMenu
  },
  methods: {
    ...mapActions(['GET_ALL', 'SAVE']),
    roleDelete: function (index, name) {
      let rolesData = Object.assign({}, this.FOR_SAVE_ROLES);
      if (this.ROLES_DATA[index].id != undefined) {
        rolesData[name + '_delete'] = {id: this.ROLES_DATA[index].id, action: 'delete'};
      } else {
        delete rolesData[name]
      }
      this.$store.commit('users/roles/FOR_SAVE_ROLES', rolesData);

      this.ROLES_DATA.splice(index, 1);
    },
    addRole: function () {
      for (let key in this.ROLES_DATA) {
        if (this.ROLES_DATA[key].name == this.name) {
          this.$bvModal.show('roleDuplicateError')
          return
        }
      }

      let roleData = {
        name: this.name,
      }
      for (let key in this.newRole) {
        roleData[key] = this.newRole[key]
      }
      // clear
      this.name = '';
      for (let key in this.newRole) {
        this.newRole[key] = false
      }

      this.$root.$emit('bv::toggle::collapse', 'addRole')

      let newRolesData = Object.assign({}, this.FOR_SAVE_ROLES);
      newRolesData[roleData.name] = roleData;
      let ROLES_DATA_COPY = this.ROLES_DATA.splice(0);
      ROLES_DATA_COPY.push(roleData)

      this.$store.commit('users/roles/FOR_SAVE_ROLES', newRolesData);
      this.$store.commit('users/roles/ROLES_DATA', ROLES_DATA_COPY);

      return false;
    },
    editCell: function (index, field) {
      let viewCell = this.$refs.rolesTable.$el.querySelectorAll('.t-cell');
      viewCell.forEach((val) => {
        val.style.display = 'inline-block';
      });

      let editCell = this.$refs.rolesTable.$el.querySelectorAll('.edit-cell');
      editCell.forEach((val) => {
        val.style.display = 'none';
      })

      this.$refs['cell_view_' + index + '_' + field].style.display = 'none';
      if (this.$refs['cell_edit_' + index + '_' + field].$el == undefined) {
        this.$refs['cell_edit_' + index + '_' + field].style.display = 'block';
      } else {
        this.$refs['cell_edit_' + index + '_' + field].$el.style.display = 'block';
      }
    },
    changeCell: function (index, field) {
      this.$refs['cell_view_' + index + '_' + field].style.display = 'inline-block';
      if (this.$refs['cell_edit_' + index + '_' + field].$el == undefined) {
        this.$refs['cell_edit_' + index + '_' + field].style.display = 'none';
      } else {
        this.$refs['cell_edit_' + index + '_' + field].$el.style.display = 'none';
      }

      let rolesData = this.FOR_SAVE_ROLES;
      rolesData[index] = this.ROLES_DATA[index];
      this.$store.commit('users/roles/FOR_SAVE_ROLES', rolesData);
    },
    changeCellSection: function (index) {
      let rolesData = this.FOR_SAVE_ROLES;
      rolesData[index] = this.ROLES_DATA[index];
      this.$store.commit('users/roles/FOR_SAVE_ROLES', rolesData);
    }
  },
  computed: {
    ...mapGetters(['ROLES_DATA', 'ROLES', 'FOR_SAVE_ROLES', 'EDIT_TOGGLE', 'IS_LOAD', 'SECTIONS_LIST']),
    fieldsLabel: function () {
      // fill label
      let fieldsLabel = []
      fieldsLabel.push({key: 'id', label: 'ID'})
      fieldsLabel.push({key: 'name', label: 'Название'})
      for (let key in this.SECTIONS_LIST) {
        let sections = this.SECTIONS_LIST[key]
        fieldsLabel.push({key: sections['name'], label: sections['alias']})
      }
      fieldsLabel.push({key: 'action', label: 'Действие'})


      return fieldsLabel
    }
  },
  mounted() {
    if (this.$store.getters.getAllowSection.indexOf('user') === -1) {
      this.$router.push({name: 'permissionDenied'});
      return;
    }
    this.GET_ALL();
  }
}
</script>

<style scoped>
.add-role {
  text-align: left;
}

.input-add-use {
  margin-top: 0.1em;
}

#roles i {
  display: inline-block;
  width: 100%;
  height: 38px;
  vertical-align: middle;
  line-height: 38px;
}

.hide {
  display: none;
}

.show {
  display: block;
}

#roles .t-cell {
  overflow: hidden;
}

.cell-cursor {
  cursor: cell;
}
</style>